import { accessCookie } from './lib/cookie'

accessCookie('roastery')

$('.js-tel-roastery').tewrap({
  phoneNumber: '03-6450-5755'
})



// WEBPACK FOOTER //
// ./src/js/roastery.js